import React from "react"
import PropTypes from "prop-types"
import { Container } from "./styles"
import Item from "./item"

const Nav = ({ items, selected, setSelected, transparent, compact, profile }) => (
  <Container compact={!!compact} profile={profile}>
    {items.map((item, index) => (
      <Item
        key={item.name}
        {...item}
        isSelected={selected === item.name}
        setSelected={setSelected}
        first={index === 0}
        last={items.length === index + 1}
        transparent={transparent}
        compact={compact}
        profile={profile}
      />
    ))}
  </Container>
)

Nav.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      clickHandler: PropTypes.func.isRequired
    })
  ).isRequired,
  selected: PropTypes.string.isRequired,
  setSelected: PropTypes.func.isRequired,
  transparent: PropTypes.bool.isRequired,
  compact: PropTypes.bool.isRequired
}

Nav.defaultProps = {
  items: [],
  selected: "",
  setSelected: undefined,
  transparent: false,
  compact: false
}

export default Nav
